import { render, staticRenderFns } from "./downloadTempFile.vue?vue&type=template&id=5d84e057&scoped=true"
import script from "./downloadTempFile.vue?vue&type=script&lang=js"
export * from "./downloadTempFile.vue?vue&type=script&lang=js"
import style0 from "./downloadTempFile.vue?vue&type=style&index=0&id=5d84e057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84e057",
  null
  
)

export default component.exports